const exampleStoreStorybook = {
  application: {
    entryPoint: 'doctors',
    staticAssetPath: '',
    error: false,
    wantGoogleMaps: false,
    naviType: 'HEALTH',
    _persist: {
      version: -1,
      rehydrated: true,
    },
  },
  search: {
    prevParams: {
      query: '',
      key: '',
      type: '',
      location: '',
      radius: '',
    },
    params: {
      key: '',
      location: '',
      query: '',
      type: '',
      radius: '',
    },
    searchLocation: {
      lat: false,
      lng: false,
    },
    count: 251207,
    isTreatmentReason: false,
    isAop: false,
    qsrIdentifier: [],
    noResults: false,
    error: false,
    clientHasSearched: true,
    from: 10,
    size: 10,
    location: [],
    results: {
      0: {
        id: 138426,
        locationName: 'Mohammed AL-Kayem',
        subjectArea: 'Augenheilkunde',
        cooperation: 'Hauck-Rohrbach Augencentren',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Im Spring 4',
          streetAddition: '',
          zip: '42489',
          city: 'Wülfrath',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 51.281131994169,
          lon: 7.0352909847062,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: true,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '0 20 58/89 66 10',
        benefits: null,
        title: 'Mohammed AL-Kayem',
        type: 'doctors',
      },
      1: {
        id: 194493,
        locationName: 'Kerstin Aab',
        subjectArea: 'Zahnmedizin',
        cooperation: 'Praxis Kerstin Aab',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Kirchenplatz 15',
          streetAddition: '',
          zip: '74211',
          city: 'Leingarten',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 49.142991968633,
          lon: 9.1236909436292,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: false,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '0 71 31/40 33 11',
        benefits: null,
        title: 'Kerstin Aab',
        type: 'doctors',
      },
      2: {
        id: 210525,
        locationName: 'Raida Aad',
        subjectArea: 'Augenheilkunde',
        cooperation: 'MVZ ADTC Siegburg GmbH',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Europaplatz 3',
          streetAddition: '',
          zip: '53721',
          city: 'Siegburg',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 50.794268957857,
          lon: 7.2031009510192,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: true,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '0 22 41/84 40 50',
        benefits: null,
        title: 'Raida Aad',
        type: 'doctors',
      },
      3: {
        id: 129761,
        locationName: 'Odd Sigmund Aakervik',
        subjectArea: 'Innere Medizin und Nephrologie',
        cooperation:
          'Gemeinschaftspraxis für Innere Medizin und Dialyse Friedrichshafen',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Röntgenstraße 14',
          streetAddition: '',
          zip: '88048',
          city: 'Friedrichshafen',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 47.672096953823,
          lon: 9.4318199132783,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: true,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '0 75 41/9 21 80',
        benefits: null,
        title: 'Odd Sigmund Aakervik',
        type: 'doctors',
      },
      4: {
        id: 177234,
        locationName: 'Odd Sigmund Aakervik',
        subjectArea: 'Innere Medizin und Nephrologie',
        cooperation: 'Dialyse Ravensburg',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Angerstraße 7 - 9',
          streetAddition: '',
          zip: '88214',
          city: 'Ravensburg',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 47.735242967544,
          lon: 9.6039829357951,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: true,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '0 75 41/9 21 80',
        benefits: null,
        title: 'Odd Sigmund Aakervik',
        type: 'doctors',
      },
      5: {
        id: 208500,
        locationName: 'Thamer Aal',
        subjectArea: 'Zahnmedizin',
        cooperation: 'Praxis Thamer Aal',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Lenneper Straße 19 a',
          streetAddition: '',
          zip: '51688',
          city: 'Wipperfürth',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 51.116590994937,
          lon: 7.3871069130842,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: true,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '0 22 67/33 06',
        benefits: null,
        title: 'Thamer Aal',
        type: 'doctors',
      },
      6: {
        id: 121221,
        locationName: 'Katrin Aalai',
        subjectArea: 'Zahnmedizin',
        cooperation: 'Gemeinschaftspraxis',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Hans-Vogel-Straße 2',
          streetAddition: '',
          zip: '90765',
          city: 'Fürth',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 49.477715987589,
          lon: 11.01367596333,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: true,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '09 11/3 73 59 88',
        benefits: null,
        title: 'Katrin Aalai',
        type: 'doctors',
      },
      7: {
        id: 121223,
        locationName: 'Daniel Aalai',
        subjectArea: 'Zahnmedizin',
        cooperation: 'Gemeinschaftspraxis',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Hans-Vogel-Straße 2',
          streetAddition: '',
          zip: '90765',
          city: 'Fürth',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 49.477715987589,
          lon: 11.01367596333,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: true,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '09 11/3 73 59 88',
        benefits: null,
        title: 'Daniel Aalai',
        type: 'doctors',
      },
      8: {
        id: 187505,
        locationName: 'Melanie Aalburg',
        subjectArea: 'Hausarzt',
        cooperation: 'Gemeinschaftspraxis',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Ollenhauerstraße 3-5',
          streetAddition: '',
          zip: '13403',
          city: 'Berlin-Reinickendorf',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 52.564282982649,
          lon: 13.328443917834,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: false,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '030/4 52 86 96',
        benefits: null,
        title: 'Melanie Aalburg',
        type: 'doctors',
      },
      9: {
        id: 101916,
        locationName: 'Dirk Jan Aarents',
        subjectArea: 'Zahnmedizin',
        cooperation: 'Gemeinschaftspraxis',
        docType: 'doctor',
        distance: 0,
        coreTeam: [],
        consultedTeam: [],
        openingHours: [],
        openingHoursInfo: '',
        address: {
          street: 'Sollingstraße 103',
          streetAddition: '',
          zip: '37603',
          city: 'Holzminden',
        },
        openIndicator: {
          state: 'no_information',
          text: 'Es liegen keine Angaben zu Öffnungszeiten vor',
        },
        coordinates: {
          lat: 51.827566971516,
          lon: 9.4609419473166,
        },
        hasOnlineAppointment: false,
        onlyPrivatePatients: {
          onlyPrivatePatients: false,
          label: null,
          tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        },
        byAppointmentOnly: false,
        isAccidentInsuranceDoctor: false,
        isDoctorInAttendance: false,
        phone: '0 55 31/70 00 47',
        benefits: null,
        title: 'Dirk Jan Aarents',
        type: 'doctors',
      },
    },
    generalHints: [],
    factsBox: [],
    showDetails: false,
    services: [],
  },
  filter: {
    initialFilterSet: true,
    activeSort: 'alphabetical',
    sorting: [
      {
        key: 'alphabetical',
        label: 'Alphabetisch',
        tip: null,
        titel: 'Alphabetisch',
      },
    ],
    collection: [
      {
        key: 'employee_friendly_opening_hours',
        type: 'boolean',
        selected: false,
        label: 'Sprechzeiten für Berufstätige',
        chip_label: null,
        tip: 'Diese Arztpraxis hat an mindestens einem Tag in der Woche vor 8 Uhr oder nach 18 Uhr geöffnet.',
        isDuplicate: null,
      },
      {
        key: 'has_online_appointment',
        type: 'boolean',
        selected: false,
        label: 'Onlineterminvereinbarung',
        chip_label: null,
        tip: null,
        isDuplicate: null,
      },
      {
        key: 'hide_only_private_patients',
        type: 'boolean',
        selected: true,
        label: 'Privatärzte ausblenden',
        chip_label: null,
        tip: 'Einige Ärzte rechnen ihre Leistungen nur privat ab. Das heißt, dass Sie in diesem Fall im Vorfeld mit Ihrer Krankenkasse klären sollten, ob diese die Kosten übernimmt.',
        isDuplicate: null,
      },
      {
        key: 'accident_insurance_doctor',
        type: 'boolean',
        selected: false,
        label: 'Durchgangsarzt',
        chip_label: null,
        tip: 'Sie hatten einen Arbeits- oder Wegeunfall? Der Unfall ist in der Kita oder Schule beziehungsweise auf dem Hin- oder Heimweg passiert? Dann sind sogenannte Durchgangsärzte (D-Ärzte) oder berufsgenossenschaftliche Ambulanzen für die Behandlung zuständig. ',
        isDuplicate: null,
      },
      {
        key: 'show_family_doctor',
        type: 'boolean',
        selected: false,
        label: 'Hausärzte anzeigen',
        chip_label: null,
        tip: null,
        isDuplicate: null,
      },
      {
        key: 'hide_family_doctor',
        type: 'boolean',
        selected: false,
        label: 'Hausärzte ausblenden',
        chip_label: null,
        tip: null,
        isDuplicate: null,
      },
      {
        key: 'medical_specialist_group',
        type: 'group',
        label: 'Fachgebiet',
        selected: false,
        options: [
          {
            key: 'medical_specialist_group_2',
            type: 'boolean',
            selected: false,
            label: 'Allgemeinmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_80',
            type: 'boolean',
            selected: false,
            label: 'Anästhesiologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_3',
            type: 'boolean',
            selected: false,
            label: 'Arbeitsmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_4',
            type: 'boolean',
            selected: false,
            label: 'Augenheilkunde',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_meta1',
            type: 'boolean',
            selected: false,
            label: 'Chirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_4570',
            type: 'boolean',
            selected: false,
            label: 'Corona-Impfungen',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_4477',
            type: 'boolean',
            selected: false,
            label: 'Corona-Schwerpunktpraxis',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_4567',
            type: 'boolean',
            selected: false,
            label: 'Corona-Schnelltest',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_10',
            type: 'boolean',
            selected: false,
            label: 'Frauenheilkunde und Geburtshilfe',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_55',
            type: 'boolean',
            selected: false,
            label: 'Gefäßchirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_12',
            type: 'boolean',
            selected: false,
            label: 'Hals-Nasen-Ohrenheilkunde',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_7',
            type: 'boolean',
            selected: false,
            label: 'Haut- und Geschlechtskrankheiten',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1090',
            type: 'boolean',
            selected: false,
            label: 'Herzchirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1186',
            type: 'boolean',
            selected: false,
            label: 'Humangenetik',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1473',
            type: 'boolean',
            selected: false,
            label: 'Hygiene und Umweltmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_14',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_458',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Angiologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_31',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Endokrinologie und Diabetologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_9',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Gastroenterologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1269',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Geriatrie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_11',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Hämatologie und Onkologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_4575',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Infektiologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_15',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Kardiologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_22',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Nephrologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_20',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Pneumologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_28',
            type: 'boolean',
            selected: false,
            label: 'Innere Medizin und Rheumatologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1665',
            type: 'boolean',
            selected: false,
            label: 'Kinder- und Jugendlichenpsychotherapeut/-in',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_17',
            type: 'boolean',
            selected: false,
            label: 'Kinder-/Jugendpsychiatrie und -psychotherapie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_927',
            type: 'boolean',
            selected: false,
            label: 'Kinderchirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_16',
            type: 'boolean',
            selected: false,
            label: 'Kinderheilkunde / Kinder- und Jugendmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_18',
            type: 'boolean',
            selected: false,
            label: 'Mund-Kiefer-Gesichtschirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_476',
            type: 'boolean',
            selected: false,
            label: 'Neurochirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_3761',
            type: 'boolean',
            selected: false,
            label: 'Neurologie und Psychiatrie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_24',
            type: 'boolean',
            selected: false,
            label: 'Nuklearmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_25',
            type: 'boolean',
            selected: false,
            label: 'Orthopädie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_2307',
            type: 'boolean',
            selected: false,
            label: 'Orthopädie und Unfallchirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1307',
            type: 'boolean',
            selected: false,
            label: 'Pharmakologie und Toxikologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1170',
            type: 'boolean',
            selected: false,
            label: 'Pharmakologie, Klinische',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_507',
            type: 'boolean',
            selected: false,
            label: 'Physikalische und Rehabilitative Medizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_2330',
            type: 'boolean',
            selected: false,
            label: 'Plastische, Rekonstruktive und Ästhetische Chirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_798',
            type: 'boolean',
            selected: false,
            label: 'Praktischer Arzt/Praktische Ärztin, Arzt/Ärztin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_23',
            type: 'boolean',
            selected: false,
            label: 'Psychiatrie und Psychotherapie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1086',
            type: 'boolean',
            selected: false,
            label: 'Psychologischer Psychotherapeut/Psychotherapeutin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1787',
            type: 'boolean',
            selected: false,
            label: 'Psychosomatische Medizin und Psychotherapie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_1144',
            type: 'boolean',
            selected: false,
            label: 'Psychotherapeutische Medizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_8',
            type: 'boolean',
            selected: false,
            label: 'Radiologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_961',
            type: 'boolean',
            selected: false,
            label: 'Rechtsmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_925',
            type: 'boolean',
            selected: false,
            label: 'Strahlentherapie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_202',
            type: 'boolean',
            selected: false,
            label: 'Transfusionsmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_30',
            type: 'boolean',
            selected: false,
            label: 'Urologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'medical_specialist_group_274',
            type: 'boolean',
            selected: false,
            label: 'Zahnmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
        ],
        isDuplicate: null,
      },
      {
        key: 'specialisation',
        type: 'group',
        label: 'Spezialisierung',
        selected: false,
        options: [
          {
            key: 'specialisation_ZB01',
            type: 'boolean',
            selected: false,
            label: 'Akupunktur',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB02',
            type: 'boolean',
            selected: false,
            label: 'Allergologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB03',
            type: 'boolean',
            selected: false,
            label: 'Andrologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB04',
            type: 'boolean',
            selected: false,
            label: 'Ärztliches Qualitätsmanagement',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB05',
            type: 'boolean',
            selected: false,
            label: 'Balneologie und Medizinische Klimatologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB06',
            type: 'boolean',
            selected: false,
            label: 'Betriebsmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB07',
            type: 'boolean',
            selected: false,
            label: 'Dermatohistologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB08',
            type: 'boolean',
            selected: false,
            label: 'Diabetologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB09',
            type: 'boolean',
            selected: false,
            label: 'Ernährungsmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB10',
            type: 'boolean',
            selected: false,
            label: 'Flugmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB11',
            type: 'boolean',
            selected: false,
            label: 'Geriatrie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB12',
            type: 'boolean',
            selected: false,
            label: 'Gynäkologische Exfoliativ-Zytologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB13',
            type: 'boolean',
            selected: false,
            label: 'Hämostaseologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB14',
            type: 'boolean',
            selected: false,
            label: 'Handchirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB15',
            type: 'boolean',
            selected: false,
            label: 'Homöopathie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB16',
            type: 'boolean',
            selected: false,
            label: 'Infektiologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB17',
            type: 'boolean',
            selected: false,
            label: 'Intensivmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB18',
            type: 'boolean',
            selected: false,
            label: 'Kardiale Magnetresonanztomographie/Kardio-MRT',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB19',
            type: 'boolean',
            selected: false,
            label: 'Kinder-Endokrinologie und -Diabetologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB20',
            type: 'boolean',
            selected: false,
            label: 'Kinder-Gastroenterologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB21',
            type: 'boolean',
            selected: false,
            label: 'Kinder-Nephrologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB22',
            type: 'boolean',
            selected: false,
            label: 'Kinder-Orthopädie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB23',
            type: 'boolean',
            selected: false,
            label: 'Kinder-Pneumologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB24',
            type: 'boolean',
            selected: false,
            label: 'Kinder-Rheumatologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB25',
            type: 'boolean',
            selected: false,
            label: 'Magnetresonanztomographie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB26',
            type: 'boolean',
            selected: false,
            label: 'Manuelle Medizin/Chirotherapie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB27',
            type: 'boolean',
            selected: false,
            label: 'Medikamentöse Tumortherapie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB28',
            type: 'boolean',
            selected: false,
            label: 'Medizinische Genetik',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB29',
            type: 'boolean',
            selected: false,
            label: 'Medizinische Informatik',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB30',
            type: 'boolean',
            selected: false,
            label: 'Naturheilverfahren',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB31',
            type: 'boolean',
            selected: false,
            label: 'Notfallmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB32',
            type: 'boolean',
            selected: false,
            label: 'Orthopädische Rheumatologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB33',
            type: 'boolean',
            selected: false,
            label: 'Palliativmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB34',
            type: 'boolean',
            selected: false,
            label: 'Phlebologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB35',
            type: 'boolean',
            selected: false,
            label: 'Physikalische Therapie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB36',
            type: 'boolean',
            selected: false,
            label:
              'Plastische Operationen (Plastische und Ästhetische Operationen)',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB37',
            type: 'boolean',
            selected: false,
            label: 'Proktologie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB38',
            type: 'boolean',
            selected: false,
            label: 'Psychoanalyse',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB39',
            type: 'boolean',
            selected: false,
            label: 'Psychotherapie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB40',
            type: 'boolean',
            selected: false,
            label: 'Rehabilitationswesen',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB41',
            type: 'boolean',
            selected: false,
            label: 'Röntgendiagnostik',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB42',
            type: 'boolean',
            selected: false,
            label: 'Schlafmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB43',
            type: 'boolean',
            selected: false,
            label: 'Sexualmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB44',
            type: 'boolean',
            selected: false,
            label: 'Sozialmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB45',
            type: 'boolean',
            selected: false,
            label: 'Spezielle Orthopädische Chirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB46',
            type: 'boolean',
            selected: false,
            label: 'Spezielle Schmerztherapie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB47',
            type: 'boolean',
            selected: false,
            label: 'Spezielle Unfallchirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB48',
            type: 'boolean',
            selected: false,
            label: 'Spezielle Viszeralchirurgie',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB49',
            type: 'boolean',
            selected: false,
            label: 'Sportmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB50',
            type: 'boolean',
            selected: false,
            label: 'Suchtmedizinische Grundversorgung',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'specialisation_ZB51',
            type: 'boolean',
            selected: false,
            label: 'Tropenmedizin',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
        ],
        isDuplicate: null,
      },
      {
        key: 'custom_opening_hours',
        type: 'group',
        label: 'Öffnungszeiten',
        selected: false,
        options: [
          {
            key: 'opening_day',
            type: 'select',
            selected: '',
            options: {
              MONDAY: 'Montag',
              TUESDAY: 'Dienstag',
              WEDNESDAY: 'Mittwoch',
              THURSDAY: 'Donnerstag',
              FRIDAY: 'Freitag',
              SATURDAY: 'Samstag',
              SUNDAY: 'Sonntag',
            },
            label: '',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
          {
            key: 'opening_time',
            type: 'select',
            selected: '',
            options: {
              1000: '10:00 Uhr',
              1100: '11:00 Uhr',
              1200: '12:00 Uhr',
              1300: '13:00 Uhr',
              1400: '14:00 Uhr',
              1500: '15:00 Uhr',
              1600: '16:00 Uhr',
              1700: '17:00 Uhr',
              1800: '18:00 Uhr',
              1900: '19:00 Uhr',
              2000: '20:00 Uhr',
              2100: '21:00 Uhr',
              2200: '22:00 Uhr',
              '0600': '06:00 Uhr',
              '0700': '07:00 Uhr',
              '0800': '08:00 Uhr',
              '0900': '09:00 Uhr',
            },
            label: '',
            chip_label: null,
            tip: null,
            isDuplicate: null,
          },
        ],
        isDuplicate: null,
      },
      {
        key: 'opened_now',
        type: 'boolean',
        selected: false,
        label: 'Jetzt geöffnet',
        chip_label: null,
        tip: null,
        isDuplicate: null,
      },
    ],
  },
  bookmarks: {
    types: {
      doctors: {
        searchParams: {
          searchKey: '',
          searchType: '',
        },
        items: [],
        count: 0,
        activeSort: 'alphabetical',
      },
      hospitals: {
        searchParams: {
          searchKey: '5-820',
          searchType: 'ops_treatment',
          searchTerm: 'Einsetzen eines künstlichen Hüftgelenkes',
        },
        count: 2,
        items: ['260200320-00', '260101809-00'],
      },
      carehomes: {
        searchParams: {
          carehomes_focus: '000',
          carehomes_care_typ: '001',
        },
        count: 2,
        items: ['3', '4'],
      },
      careservices: {
        searchParams: {
          PE_ANG_KRANKENPFLEGE: '',
        },
        items: [],
        count: 0,
        activeSort: 'alphabetical',
      },
      dayandnightcare: {
        searchParams: {
          PR_TYP: '',
          PR_PFGRAD: '',
          PR_PFDAYS: '',
        },
        items: [],
        count: 0,
        activeSort: 'alphabetical',
      },
      caresupport: {
        searchParams: {
          searchKey: '',
          searchType: '',
        },
        items: [],
        count: 0,
        activeSort: 'alphabetical',
      },
    },
    totalCount: 4,
    selectedDetails: {
      results: [
        {
          id: '3',
          locationName: '"Drei Linden" Seniorenpflegestift',
          address: {
            street: 'Auf der Stichel 28',
            streetAddition: '',
            zip: '63762',
            city: 'Großostheim',
          },
          coordinates: {
            lat: 49.91117996018,
            lon: 9.0576249748793,
          },
          distance: 0,
          contribution: [
            {
              amount: '1.760,74 €',
              careLevel: '1',
              tooltip: 'zzgl. Investitionskosten',
              contractId: null,
              type: 'personalContribution',
            },
            {
              amount: '1.458,64 €',
              careLevel: '2-5',
              tooltip: 'zzgl. Investitionskosten',
              contractId: null,
              type: 'personalContribution',
            },
          ],
          phone: '06026 / 97260',
          fax: '06026 / 972648',
          benefits: null,
          email: 'drei.linden@t-online.de',
          website: 'http://www.dreilinden-seniorenpflege.de',
          transparencyReport: null,
          title: '"Drei Linden" Seniorenpflegestift',
          type: 'carehomes',
        },
        {
          id: '4',
          locationName: '"Finkenhof" Senioren- & Pflegeheim',
          address: {
            street: 'Finkenweg 2',
            streetAddition: '',
            zip: '83253',
            city: 'Rimsting',
          },
          coordinates: {
            lat: 47.879117959865,
            lon: 12.338356923952,
          },
          distance: 0,
          contribution: [
            {
              amount: '2.360,01 €',
              careLevel: '1',
              tooltip: 'zzgl. Investitionskosten',
              contractId: null,
              type: 'personalContribution',
            },
            {
              amount: '2.205,75 €',
              careLevel: '2-5',
              tooltip: 'zzgl. Investitionskosten',
              contractId: null,
              type: 'personalContribution',
            },
          ],
          phone: '08051 / 963540',
          fax: '08051 / 96354210',
          benefits: null,
          email: 'info@finkenhof-rimsting.de',
          website: 'http://www.finkenhof-rimsting.de',
          transparencyReport: null,
          title: '"Finkenhof" Senioren- & Pflegeheim',
          type: 'carehomes',
        },
      ],
      generalTooltips: {
        transparencyReport:
          'Dieser Transparenzbericht wurde auf Grundlage der ab 1. Januar 2017 gültigen Pflegetransparenzverordnung erstellt. Ein direkter Vergleich der Bewertung mit Transparenzberichten oder Berichten zu Qualitätsprüfungen nach einer anderen Prüfgrundlage ist aufgrund der unterschiedlichen Bewertungssystematik nicht möglich.',
        distance:
          'Die hier dargestellte Entfernungsangabe basiert auf der Entfernung einer von Google berechneten Route.',
      },
      query: '',
      location: [],
      isUnknownSearch: true,
      type: '',
      key: '',
      from: 0,
      size: 10,
      count: 2,
      is_treatment_reason: false,
      is_aop: false,
      generalHints: [],
      filters: [],
      sorting: [],
      active_sorting: 'alphabetical',
      show_details: false,
      aokServices: [],
    },
    overlay: {
      show: false,
      bookmarkToAdd: null,
    },
  },
  detailData: null,
  apiError: false,
  compare: {
    types: {
      doctors: {
        detailsKeyArray: [],
        count: 0,
        results: [],
      },
      hospitals: {
        detailsKeyArray: ['locationInfo', 'locations'],
        results: [
          {
            id: '260200320-00',
            locationName: 'Helios ENDO-Klinik Hamburg',
            address: {
              street: 'Holstenstraße 2',
              streetAddition: '',
              zip: '22767',
              city: 'Hamburg',
            },
            coordinates: {
              lat: 53.551190976756,
              lon: 9.9552939211519,
            },
            peq: {
              general: 94,
              cases: 398,
              average: 81,
            },
            qsr: [
              {
                identifier: 'EHTEP',
                title: 'Hüftgelenkersatz bei Gelenkverschleiß (Arthrose)',
                text: 'Überdurchschnittliche Qualität für "Hüftgelenkersatz bei Gelenkverschleiß (Arthrose)".',
                rating: 3,
                info: null,
                tooltip: null,
                indicators: [],
                status: 0,
                sorting: 0,
              },
            ],
            iqtig: null,
            hospital: null,
            treatment: {
              department_id: '',
              department_name: '',
              year: '2019',
              cases: 2259,
              cases_ambulant: 0,
              is_ambulant_treatment: false,
              scoring: 'HIGH',
              cases_ambulant_scoring: null,
              treatment_tip:
                'Der Wert ist im Vergleich zu den Werten anderer Krankenhäuser hoch, er liegt im oberen Viertel.\n',
              ambulant_treatment_tip: null,
              treatmentCases: 2259,
            },
            distance: 0,
            qsrIndicators: [],
            benefits: null,
            generalTooltips: {
              treatmentCases:
                'Angegeben wird die  Anzahl jährlicher Behandlungsfälle für den gesuchten Eingriff. Die Information stammt aus dem Strukturierten Qualitätsbericht des Krankenhauses. Es kann zu geringfügigen Abweichungen gegenüber der tatsächlichen Fallzahl kommen, da geringe Fallzahlen aus Datenschutzgründen nicht genau angezeigt und abgebildet werden dürfen. Je höher die Zahl der Behandlungsfälle ist, desto mehr Erfahrung hat das Krankenhaus mit der jeweiligen Behandlung.  ',
              treatmentCasesAmbulant:
                'Das Krankenhaus ist berechtigt, seltene Erkrankungen, Erkrankungen mit besonderen Krankheitsverläufen und/oder hochspezialisierten Leistungen ambulant zu erbringen.',
              recommendation:
                'Ein Prozentwert von 100% bedeutet, dass alle befragten Patienten dieses Krankenhaus ihrem besten Freund/ihrer besten Freundin weiterempfehlen würden. Die weiße Linie im Balken markiert den Bundesdurchschnitt der Weiterempfehlung, bezogen auf alle deutschen Krankenhäuser. Liegt die weiße Linie im dunkelblauen Bereich, wird dieses Krankenhaus häufiger weiterempfohlen als im Bundesdurchschnitt. Liegt die weiße Linie im hellblauen Bereich, wird dieses Krankenhaus seltener weiterempfohlen als im Bundesdurchschnitt.  Mehr Informationen zu den Patientenbewertungen für dieses Krankenhaus erhalten Sie im Detailprofil. Erläuterungen zum Verfahren finden Sie <a title="Link zum PEQ Verfahren" href="https://www.aok.de/pk/uni/inhalt/versichertenbefragung-peq/" target="_blank" rel="noopener">hier</a>.',
              qsr: 'Mehr Informationen zu den Qualitätsergebnissen für dieses Krankenhaus erhalten Sie im Detailprofil. Das QSR-Verfahren beurteilt die Qualität einer Behandlung anhand von möglichen Komplikationen bzw. unerwünschten Ereignissen. Diese können sowohl während des Krankenhausaufenthalts als auch bis zu einem Jahr nach dem betrachteten Eingriff auftreten. Ausgewertet wurden Eingriffe bei AOK-Patienten über einen mehrjährigen, im Detailprofil angegebenen Zeitraum.\nDie Symbole bedeuten:\n<p>3 grüne Lebensbäume: überdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer geringen Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>2 grüne Lebensbäume: durchschnittliche Qualität (d.h. eine Klinik gehört zu den 60% der Kliniken mit einer mittleren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>1 grüner Lebensbaum: unterdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer höheren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\nMehr zum QSR-Verfahren finden Sie <a title="Link zum QSR Verfahren" href="https://www.qualitaetssicherung-mit-routinedaten.de/" target="_blank" rel="noopener">hier</a>.',
              iqtig:
                'Alle Krankenhäuser sind verpflichtet, qualitätsrelevante Daten (Qualitätsindikatoren) zur Versorgung ihrer Patientinnen und Patienten zu dokumentieren, die dann vom Institut für Qualitätssicherung und Transparenz im Gesundheitswesen (IQTiG) vergleichend ausgewertet werden. Das IQTIG ist das zentrale Institut für die gesetzlich verankerte Qualitätssicherung im Gesundheitswesen in Deutschland und arbeitet im Auftrag des Gemeinsamen Bundesausschusses.',
            },
            isApo: false,
            details: {
              locationInfo: [
                {
                  address: {
                    zip: '22767',
                    city: 'Hamburg',
                    street: 'Holstenstraße 2',
                    streetAddition: '',
                    title: 'Helios ENDO-Klinik Hamburg',
                    phone: '',
                  },
                  accessibility: {
                    distance: 'Entfernung 0.96 km',
                    nextStop: null,
                    freeParking: '',
                  },
                  marker: {
                    lon: 9.9552939211519,
                    lat: 53.551190976756,
                  },
                },
              ],
              locations: [
                {
                  address: {
                    title: 'Helios ENDO-Klinik Hamburg',
                    street: 'Holstenstraße 2',
                    zip: '22767',
                    city: 'Hamburg',
                    phone: '',
                  },
                  marker: {
                    lat: 53.551190976756,
                    lon: 9.9552939211519,
                  },
                },
              ],
              departmentsList: [
                {
                  title: 'Helios ENDO-Klinik Hamburg',
                  linkList: [
                    {
                      label: 'Wirbelsäulenchirurgie und Neurochirurgie',
                      url: '',
                    },
                    {
                      label: 'Septische Gelenkchirurgie',
                      url: '',
                    },
                    {
                      label:
                        'Gelenkchirurgie/ Orthopädie/septische Gelenkchirurgie',
                      url: '',
                    },
                    {
                      label:
                        'Anästhesiologie, Intensiv- und Transfusionsmedizin',
                      url: '',
                    },
                    {
                      label: 'Anästhesie',
                      url: '',
                    },
                  ],
                },
              ],
              peq: {
                cases: 398,
                year: '2019',
                tooltip:
                  'Wir zeigen Ihnen, welche Erfahrungen andere Patienten während eines Krankenhausaufenthalts gemacht haben. Die angezeigten Ergebnisse beruhen auf einer groß angelegten Befragung von Patienten, die nach ihrem Krankenhausaufenthalt einen Fragebogen ausgefüllt haben. Basis sind die Bewertungen aller Patienten der Fachabteilung bzw. des Krankenhauses, die Befragung erfolgte unabhängig von der durchgeführten Behandlung. Die angezeigte Fallzahl für die gesuchte Behandlung und die Zahl vorliegender Bewertungen können daher voneinander abweichen. Bisher sind bundesweit rund 900.000 Bewertungen von Versicherten der AOK und anderer beteiligter Krankenkassen eingeflossen. Damit handelt es sich um die bisher größte Versichertenbefragung in Europa. Die Ergebnisse werden mehrmals jährlich aktualisiert. Erläuterungen zum Verfahren finden Sie <a title="Link zum PEQ Verfahren" href="https://www.aok.de/pk/uni/inhalt/versichertenbefragung-peq/" target="_blank" rel="noopener">hier</a>.',
                additionalInfo: null,
                default: {
                  overall: {
                    percentValue: 94,
                    averagePercentValue: 81,
                  },
                  allocation: {
                    'Ärztlicher Versorgung': {
                      percentValue: 91,
                      averagePercentValue: 83,
                      allocation: {
                        'Wie beurteilen Sie den Umgang der Ärztinnen und Ärzte im Krankenhaus mit Ihnen?':
                          {
                            percentValue: 90,
                          },
                        'Wurden Sie von den Ärztinnen und Ärzten im Krankenhaus insgesamt angemessen informiert?':
                          {
                            percentValue: 89,
                          },
                        'Wie schätzen Sie die Qualität der medizinischen Versorgung in Ihrem Krankenhaus ein?':
                          {
                            percentValue: 94,
                          },
                      },
                    },
                    'Pflegerischer Betreuung': {
                      percentValue: 88,
                      averagePercentValue: 82,
                      allocation: {
                        'Wurden Ihre Wünsche und Bedenken in der Betreuung durch die Pflegekräfte berücksichtigt?':
                          {
                            percentValue: 88,
                          },
                        'Wie beurteilen Sie den Umgang der Pflegekräfte mit Ihnen?':
                          {
                            percentValue: 90,
                          },
                        'Wurden Sie von den Pflegekräften insgesamt angemessen informiert?':
                          {
                            percentValue: 86,
                          },
                        'Wie schätzen Sie die Qualität der pflegerischen Betreuung in Ihrem Krankenhaus ein?':
                          {
                            percentValue: 88,
                          },
                      },
                    },
                    'Organisation und Service': {
                      percentValue: 84,
                      averagePercentValue: 77,
                      allocation: {
                        'Mussten Sie während Ihres Krankenhausaufenthaltes häufig warten?':
                          {
                            percentValue: 84,
                          },
                        'Verlief die Aufnahme ins Krankenhaus zügig und reibungslos?':
                          {
                            percentValue: 86,
                          },
                        'Wie beurteilen Sie die Sauberkeit in Ihrem Krankenhaus?':
                          {
                            percentValue: 84,
                          },
                        'Entsprach die Essensversorgung im Krankenhaus Ihren Bedürfnissen?':
                          {
                            percentValue: 87,
                          },
                        'Wie gut war Ihre Entlassung durch das Krankenhaus organisiert?':
                          {
                            percentValue: 81,
                          },
                      },
                    },
                  },
                },
                departments: [
                  {
                    hospitalId: '706',
                    name: 'Wirbelsäulenchirurgie und Neurochirurgie',
                    treatments: {
                      cases: 0,
                    },
                    overall: {
                      percentValue: 0,
                      averagePercentValue: 81,
                    },
                    allocation: {
                      'Ärztlicher Versorgung': {
                        percentValue: 0,
                        averagePercentValue: 83,
                        allocation: [],
                      },
                      'Pflegerischer Betreuung': {
                        percentValue: 0,
                        averagePercentValue: 82,
                        allocation: [],
                      },
                      'Organisation und Service': {
                        percentValue: 0,
                        averagePercentValue: 77,
                        allocation: [],
                      },
                    },
                  },
                  {
                    hospitalId: '707',
                    name: 'Septische Gelenkchirurgie',
                    treatments: {
                      cases: 0,
                    },
                    overall: {
                      percentValue: 0,
                      averagePercentValue: 81,
                    },
                    allocation: {
                      'Ärztlicher Versorgung': {
                        percentValue: 0,
                        averagePercentValue: 83,
                        allocation: [],
                      },
                      'Pflegerischer Betreuung': {
                        percentValue: 0,
                        averagePercentValue: 82,
                        allocation: [],
                      },
                      'Organisation und Service': {
                        percentValue: 0,
                        averagePercentValue: 77,
                        allocation: [],
                      },
                    },
                  },
                  {
                    hospitalId: '708',
                    name: 'Gelenkchirurgie/ Orthopädie/septische Gelenkchirurgie',
                    treatments: {
                      cases: 0,
                    },
                    overall: {
                      percentValue: 94,
                      averagePercentValue: 81,
                    },
                    allocation: {
                      'Ärztlicher Versorgung': {
                        percentValue: 91,
                        averagePercentValue: 83,
                        allocation: {
                          'Wurden Ihre Wünsche und Bedenken in der ärztlichen Behandlung berücksichtigt?':
                            {
                              percentValue: 89,
                            },
                          'Wie beurteilen Sie den Umgang der Ärztinnen und Ärzte im Krankenhaus mit Ihnen?':
                            {
                              percentValue: 90,
                            },
                          'Wurden Sie von den Ärztinnen und Ärzten im Krankenhaus insgesamt angemessen informiert?':
                            {
                              percentValue: 89,
                            },
                          'Wie schätzen Sie die Qualität der medizinischen Versorgung in Ihrem Krankenhaus ein?':
                            {
                              percentValue: 94,
                            },
                        },
                      },
                      'Pflegerischer Betreuung': {
                        percentValue: 88,
                        averagePercentValue: 82,
                        allocation: {
                          'Wurden Ihre Wünsche und Bedenken in der Betreuung durch die Pflegekräfte berücksichtigt?':
                            {
                              percentValue: 88,
                            },
                          'Wie beurteilen Sie den Umgang der Pflegekräfte mit Ihnen?':
                            {
                              percentValue: 89,
                            },
                          'Wurden Sie von den Pflegekräften insgesamt angemessen informiert?':
                            {
                              percentValue: 86,
                            },
                          'Wie schätzen Sie die Qualität der pflegerischen Betreuung in Ihrem Krankenhaus ein?':
                            {
                              percentValue: 88,
                            },
                        },
                      },
                      'Organisation und Service': {
                        percentValue: 85,
                        averagePercentValue: 77,
                        allocation: {
                          'Mussten Sie während Ihres Krankenhausaufenthaltes häufig warten?':
                            {
                              percentValue: 84,
                            },
                          'Verlief die Aufnahme ins Krankenhaus zügig und reibungslos?':
                            {
                              percentValue: 87,
                            },
                          'Wie beurteilen Sie die Sauberkeit in Ihrem Krankenhaus?':
                            {
                              percentValue: 85,
                            },
                          'Entsprach die Essensversorgung im Krankenhaus Ihren Bedürfnissen?':
                            {
                              percentValue: 87,
                            },
                          'Wie gut war Ihre Entlassung durch das Krankenhaus organisiert?':
                            {
                              percentValue: 80,
                            },
                        },
                      },
                    },
                  },
                ],
              },
              locationDepartments: [
                {
                  'Wirbelsäulenchirurgie und Neurochirurgie': 503,
                },
                {
                  'Septische Gelenkchirurgie': 406,
                },
                {
                  'Gelenkchirurgie/ Orthopädie/septische Gelenkchirurgie': 7155,
                },
                {
                  'Anästhesiologie, Intensiv- und Transfusionsmedizin': 0,
                },
                {
                  Anästhesie: 0,
                },
              ],
              quality: {
                qsr: {
                  data: [
                    {
                      id: 'EHTEP',
                      headline:
                        'Hüftgelenkersatz bei Gelenkverschleiß (Arthrose)',
                      status: 0,
                      qsrHeaderText:
                        'Überdurchschnittliche Qualität für "Hüftgelenkersatz bei Gelenkverschleiß (Arthrose)".',
                      tooltip:
                        'Mehr Informationen zu den Qualitätsergebnissen für dieses Krankenhaus erhalten Sie im Detailprofil. Das QSR-Verfahren beurteilt die Qualität einer Behandlung anhand von möglichen Komplikationen bzw. unerwünschten Ereignissen. Diese können sowohl während des Krankenhausaufenthalts als auch bis zu einem Jahr nach dem betrachteten Eingriff auftreten. Ausgewertet wurden Eingriffe bei AOK-Patienten über einen mehrjährigen, im Detailprofil angegebenen Zeitraum.\nDie Symbole bedeuten:\n<p>3 grüne Lebensbäume: überdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer geringen Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>2 grüne Lebensbäume: durchschnittliche Qualität (d.h. eine Klinik gehört zu den 60% der Kliniken mit einer mittleren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>1 grüner Lebensbaum: unterdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer höheren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\nMehr zum QSR-Verfahren finden Sie <a title="Link zum QSR Verfahren" href="https://www.qualitaetssicherung-mit-routinedaten.de/" target="_blank" rel="noopener">hier</a>.',
                      copy: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                      info: null,
                      treatmentCases:
                        'Einbezogene AOK-Behandlungsfälle: 772 (2016-2018)',
                      treatmentCasesTooltip:
                        'Die Ergebnisse basieren auf einer Analyse des Krankheitsverlaufs von 772 AOK-Patienten in den Jahren  2016 bis 2018. Das sind AOK-Patienten, die in diesem Zeitraum wegen des Einsetzens eines künstlichen Hüftgelenks in dieser Klinik operiert wurden.',
                      table: [
                        {
                          id: 'INDEX',
                          indicator:
                            'Gesamtbewertung für diesen Leistungsbereich',
                          order: 1,
                          tooltip: {
                            title: '',
                            tip: '',
                          },
                          result: {
                            rating: 'high',
                            value: '0.8',
                            range: '(0.5 - 1.1)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen, chirurgische Komplikationen,Todesfälle oder hüftgelenksnaher Bruch des Oberschenkelknochens) geringer als in anderen Krankenhäusern.\nDie Zahl 0.8 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.5 und 1.1.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen, chirurgische Komplikationen,Todesfälle oder hüftgelenksnaher Bruch des Oberschenkelknochens) geringer als in anderen Krankenhäusern.\nDie Zahl 0.8 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.5 und 1.1.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen, chirurgische Komplikationen,Todesfälle oder hüftgelenksnaher Bruch des Oberschenkelknochens) geringer als in anderen Krankenhäusern.\nDie Zahl 0.8 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.5 und 1.1.',
                            },
                          },
                        },
                        {
                          id: 'REVISION',
                          indicator:
                            'Ungeplante Folge-Operation bis zu 365 Tage nach dem Eingriff',
                          order: 2,
                          tooltip: {
                            title: '',
                            tip: 'Wenn sich nach dem chirurgischen Eingriff das Operationsgebiet entzündet oder die Prothese lockert, kann unter Umständen eine erneute Operation notwendig sein.',
                          },
                          result: {
                            rating: 'high',
                            value: '0.4',
                            range: '(0.0 - 0.8)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.4 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 0.8.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.4 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 0.8.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.4 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 0.8.',
                            },
                          },
                        },
                        {
                          id: 'CHIRKOMP',
                          indicator:
                            'Chirurgische Komplikationen innerhalb von 90 bzw. 365 Tagen nach dem Eingriff',
                          order: 3,
                          tooltip: {
                            title: '',
                            tip: 'Zu den chirurgischen Komplikationen beim Einsetzen eines künstlichen Hüftgelenks zählen unter anderem Infektionen durch die Prothese, Verletzungen von Blutgefäßen sowie das Lockern des künstlichen Gelenks.   ',
                          },
                          result: {
                            rating: 'high',
                            value: '0.6',
                            range: '(0.3 - 1.0)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.6 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.3 und 1.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.6 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.3 und 1.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.6 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.3 und 1.',
                            },
                          },
                        },
                        {
                          id: 'TOD90',
                          indicator:
                            'Sterblichkeit innerhalb von 90 Tagen nach dem Eingriff',
                          order: 4,
                          tooltip: {
                            title: '',
                            tip: 'Beim geplanten Einsetzen eines künstlichen Hüftgelenks ist es höchst selten, dass Patienten an den Folgen der Operation sterben. Dennoch können Komplikationen in seltenen Einzelfällen zum Tod führen.',
                          },
                          result: {
                            rating: 'high',
                            value: '0.3',
                            range: '(0.0 - 1.5)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.3 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.5.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.3 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.5.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.3 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.5.',
                            },
                          },
                        },
                        {
                          id: 'FEMFRAK',
                          indicator:
                            'Hüftgelenksnaher Bruch des Oberschenkelknochens innerhalb von 90 Tagen nach dem Eingriff',
                          order: 5,
                          tooltip: {
                            title: '',
                            tip: 'Brüche des Oberschenkelknochens nach der Operation beeinträchtigen den Heilungsprozess. Im schlimmsten Fall können sie dazu führen, dass die Hüftprothese sich lockert und ein erneuter Eingriff notwendig wird.',
                          },
                          result: {
                            rating: 'low',
                            value: '1.2',
                            range: '(0.7 - 1.6)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit, sich den Oberschenkelknochen hüftgelenksnah zu brechen, höher als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit, sich den Oberschenkelknochen hüftgelenksnah zu brechen, höher als in den meisten anderen Krankenhäusern.\nDie Zahl 1.2 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.7 und 1.6.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit, sich den Oberschenkelknochen hüftgelenksnah zu brechen, höher als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit, sich den Oberschenkelknochen hüftgelenksnah zu brechen, höher als in den meisten anderen Krankenhäusern.\nDie Zahl 1.2 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.7 und 1.6.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit, sich den Oberschenkelknochen hüftgelenksnah zu brechen, höher als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit, sich den Oberschenkelknochen hüftgelenksnah zu brechen, höher als in den meisten anderen Krankenhäusern.\nDie Zahl 1.2 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.7 und 1.6.',
                            },
                          },
                        },
                      ],
                    },
                    {
                      id: 'KNIETEP',
                      headline:
                        'Kniegelenkersatz bei Gelenkverschleiß (Arthrose)',
                      status: 0,
                      qsrHeaderText:
                        'Überdurchschnittliche Qualität für "Kniegelenkersatz bei Gelenkverschleiß (Arthrose)".',
                      tooltip:
                        'Mehr Informationen zu den Qualitätsergebnissen für dieses Krankenhaus erhalten Sie im Detailprofil. Das QSR-Verfahren beurteilt die Qualität einer Behandlung anhand von möglichen Komplikationen bzw. unerwünschten Ereignissen. Diese können sowohl während des Krankenhausaufenthalts als auch bis zu einem Jahr nach dem betrachteten Eingriff auftreten. Ausgewertet wurden Eingriffe bei AOK-Patienten über einen mehrjährigen, im Detailprofil angegebenen Zeitraum.\nDie Symbole bedeuten:\n<p>3 grüne Lebensbäume: überdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer geringen Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>2 grüne Lebensbäume: durchschnittliche Qualität (d.h. eine Klinik gehört zu den 60% der Kliniken mit einer mittleren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>1 grüner Lebensbaum: unterdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer höheren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\nMehr zum QSR-Verfahren finden Sie <a title="Link zum QSR Verfahren" href="https://www.qualitaetssicherung-mit-routinedaten.de/" target="_blank" rel="noopener">hier</a>.',
                      copy: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                      info: null,
                      treatmentCases:
                        'Einbezogene AOK-Behandlungsfälle: 879 (2016-2018)',
                      treatmentCasesTooltip:
                        'Die Ergebnisse basieren auf einer Analyse des Krankheitsverlaufs von 879 AOK-Patienten in den Jahren  2016 bis 2018. Das sind AOK-Patienten, die in diesem Zeitraum wegen des Einsetzens eines künstlichen Kniegelenks in dieser Klinik operiert wurden.',
                      table: [
                        {
                          id: 'INDEX',
                          indicator:
                            'Gesamtbewertung für diesen Leistungsbereich',
                          order: 1,
                          tooltip: {
                            title: '',
                            tip: '',
                          },
                          result: {
                            rating: 'high',
                            value: '0.4',
                            range: '(0.1 - 0.7)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen, chirurgische Komplikationen oder Todesfälle) geringer als in anderen Krankenhäusern. \nDie Zahl 0.4 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.1 und 0.7.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen, chirurgische Komplikationen oder Todesfälle) geringer als in anderen Krankenhäusern. \nDie Zahl 0.4 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.1 und 0.7.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen, chirurgische Komplikationen oder Todesfälle) geringer als in anderen Krankenhäusern. \nDie Zahl 0.4 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.1 und 0.7.',
                            },
                          },
                        },
                        {
                          id: 'REVISION',
                          indicator:
                            'Ungeplante Folge-Operation bis zu 365 Tage nach dem Eingriff',
                          order: 2,
                          tooltip: {
                            title: '',
                            tip: 'Wenn sich nach dem chirurgischen Eingriff das Operationsgebiet entzündet oder die Prothese lockert, kann unter Umständen eine erneute Operation notwendig sein.',
                          },
                          result: {
                            rating: 'high',
                            value: '0.2',
                            range: '(0.0 - 0.6)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.2 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 0.6.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.2 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 0.6.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.2 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 0.6.',
                            },
                          },
                        },
                        {
                          id: 'CHIRKOMP',
                          indicator:
                            'Chirurgische Komplikationen innerhalb von 90 bzw. 365 Tagen nach dem Eingriff',
                          order: 3,
                          tooltip: {
                            title: '',
                            tip: 'Zu den chirurgischen Komplikationen beim Einsetzen eines künstlichen Kniegelenks zählen unter anderem Infektionen durch die Prothese, Verletzungen von Blutgefäßen, das Aufreißen der Operationswunde sowie das Lockern des künstlichen Gelenks.',
                          },
                          result: {
                            rating: 'high',
                            value: '0.6',
                            range: '(0.2 - 0.9)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.6 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.2 und 0.9.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.6 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.2 und 0.9.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer chirurgischen Komplikation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.6 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.2 und 0.9.',
                            },
                          },
                        },
                        {
                          id: 'TOD90',
                          indicator:
                            'Sterblichkeit innerhalb von 90 Tagen nach dem Eingriff',
                          order: 4,
                          tooltip: {
                            title: '',
                            tip: 'Beim geplanten Einsetzen eines künstlichen Kniegelenks ist es höchst selten, dass Patienten an den Folgen der Operation sterben. Dennoch können Komplikationen in seltenen Einzelfällen zum Tod führen.',
                          },
                          result: {
                            rating: 'high',
                            value: '0.0',
                            range: '(0.0 - 1.4)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.4.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.4.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit  zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.4.',
                            },
                          },
                        },
                      ],
                    },
                    {
                      id: 'HEPW',
                      headline:
                        'Hüftprothesenwechsel (nicht bei Knochenbruch oder Infektion)',
                      status: 0,
                      qsrHeaderText:
                        'Überdurchschnittliche Qualität für "Hüftprothesenwechsel".',
                      tooltip:
                        'Mehr Informationen zu den Qualitätsergebnissen für dieses Krankenhaus erhalten Sie im Detailprofil. Das QSR-Verfahren beurteilt die Qualität einer Behandlung anhand von möglichen Komplikationen bzw. unerwünschten Ereignissen. Diese können sowohl während des Krankenhausaufenthalts als auch bis zu einem Jahr nach dem betrachteten Eingriff auftreten. Ausgewertet wurden Eingriffe bei AOK-Patienten über einen mehrjährigen, im Detailprofil angegebenen Zeitraum.\nDie Symbole bedeuten:\n<p>3 grüne Lebensbäume: überdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer geringen Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>2 grüne Lebensbäume: durchschnittliche Qualität (d.h. eine Klinik gehört zu den 60% der Kliniken mit einer mittleren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>1 grüner Lebensbaum: unterdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer höheren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\nMehr zum QSR-Verfahren finden Sie <a title="Link zum QSR Verfahren" href="https://www.qualitaetssicherung-mit-routinedaten.de/" target="_blank" rel="noopener">hier</a>.',
                      copy: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                      info: null,
                      treatmentCases:
                        'Einbezogene AOK-Behandlungsfälle: 346 (2016-2018)',
                      treatmentCasesTooltip:
                        'Die Ergebnisse basieren auf einer Analyse des Krankheitsverlaufs von 346 AOK-Patienten in den Jahren 2016 bis 2018. Das sind AOK-Patienten, die in diesem Zeitraum wegen eines Hüftprothesenwechsels (nicht bei Knochenbruch oder Infektion) in dieser Klinik operiert wurden.',
                      table: [
                        {
                          id: 'INDEX',
                          indicator:
                            'Gesamtbewertung für diesen Leistungsbereich',
                          order: 1,
                          tooltip: {
                            title: '',
                            tip: '',
                          },
                          result: {
                            rating: 'high',
                            value: '1.0',
                            range: '(0.8 - 1.3)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen oder Todesfälle) geringer als in anderen Krankenhäusern.\nDie Zahl 1 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.8 und 1.3.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen oder Todesfälle) geringer als in anderen Krankenhäusern.\nDie Zahl 1 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.8 und 1.3.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen oder Todesfälle) geringer als in anderen Krankenhäusern.\nDie Zahl 1 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.8 und 1.3.',
                            },
                          },
                        },
                        {
                          id: 'REVISION',
                          indicator:
                            'Ungeplante Folge-OP innerhalb von 365 Tagen',
                          order: 2,
                          tooltip: {
                            title: '',
                            tip: 'Wenn sich nach der Wechseloperation das Operationsgebiet entzündet oder die Prothese lockert, kann unter Umständen ein erneuter Eingriff notwendig sein.',
                          },
                          result: {
                            rating: 'high',
                            value: '1.0',
                            range: '(0.7 - 1.2)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 1 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.7 und 1.2.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 1 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.7 und 1.2.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 1 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.7 und 1.2.',
                            },
                          },
                        },
                        {
                          id: 'TOD90',
                          indicator:
                            'Sterblichkeit innerhalb von 90 Tagen nach dem Eingriff',
                          order: 3,
                          tooltip: {
                            title: '',
                            tip: 'Bei dem geplanten Wechsel eines künstlichen Hüftgelenks ist es höchst selten, dass Patienten an den Folgen der Operation sterben. Dennoch können Komplikationen in seltenen Einzelfällen zum Tod führen. ',
                          },
                          result: {
                            rating: 'high',
                            value: '0.5',
                            range: '(0.0 - 1.4)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.4.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.4.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.4.',
                            },
                          },
                        },
                      ],
                    },
                    {
                      id: 'KEPW',
                      headline:
                        'Knieprothesenwechsel (nicht bei Knochenbruch oder Infektion)',
                      status: 0,
                      qsrHeaderText:
                        'Überdurchschnittliche Qualität für "Knieprothesenwechsel (nicht bei Knochenbruch oder Infektion)".',
                      tooltip:
                        'Mehr Informationen zu den Qualitätsergebnissen für dieses Krankenhaus erhalten Sie im Detailprofil. Das QSR-Verfahren beurteilt die Qualität einer Behandlung anhand von möglichen Komplikationen bzw. unerwünschten Ereignissen. Diese können sowohl während des Krankenhausaufenthalts als auch bis zu einem Jahr nach dem betrachteten Eingriff auftreten. Ausgewertet wurden Eingriffe bei AOK-Patienten über einen mehrjährigen, im Detailprofil angegebenen Zeitraum.\nDie Symbole bedeuten:\n<p>3 grüne Lebensbäume: überdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer geringen Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>2 grüne Lebensbäume: durchschnittliche Qualität (d.h. eine Klinik gehört zu den 60% der Kliniken mit einer mittleren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>1 grüner Lebensbaum: unterdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer höheren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\nMehr zum QSR-Verfahren finden Sie <a title="Link zum QSR Verfahren" href="https://www.qualitaetssicherung-mit-routinedaten.de/" target="_blank" rel="noopener">hier</a>.',
                      copy: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                      info: null,
                      treatmentCases:
                        'Einbezogene AOK-Behandlungsfälle: 404 (2014-2018)',
                      treatmentCasesTooltip:
                        'Die Ergebnisse basieren auf einer Analyse des Krankheitsverlaufs von 404 AOK-Patienten in den Jahren  2014 bis 2018. Das sind AOK-Patienten, die in diesem Zeitraum wegen eines Knieprothesenwechsels (nicht bei Knochenbruch oder Infektion) in dieser Klinik operiert wurden.',
                      table: [
                        {
                          id: 'INDEX',
                          indicator:
                            'Gesamtbewertung für diesen Leistungsbereich',
                          order: 1,
                          tooltip: {
                            title: '',
                            tip: '',
                          },
                          result: {
                            rating: 'high',
                            value: '0.5',
                            range: '(0.2 - 0.8)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen oder Todesfälle) geringer als in anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.2 und 0.8.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen oder Todesfälle) geringer als in anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.2 und 0.8.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen geringer als in anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit von Komplikationen (ungeplante Folgeoperationen oder Todesfälle) geringer als in anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.2 und 0.8.',
                            },
                          },
                        },
                        {
                          id: 'REVISION',
                          indicator:
                            'Ungeplante Folge-OP innerhalb von 365 Tagen',
                          order: 2,
                          tooltip: {
                            title: '',
                            tip: 'Wenn sich nach der Wechseloperation das Operationsgebiet entzündet oder die Prothese lockert, kann unter Umständen ein erneuter Eingriff notwendig sein.',
                          },
                          result: {
                            rating: 'high',
                            value: '0.5',
                            range: '(0.2 - 0.8)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.2 und 0.8.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.2 und 0.8.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit einer ungeplanten Folgeoperation geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0.2 und 0.8.',
                            },
                          },
                        },
                        {
                          id: 'TOD90',
                          indicator:
                            'Sterblichkeit innerhalb von 90 Tagen nach dem Eingriff',
                          order: 3,
                          tooltip: {
                            title: '',
                            tip: 'Bei dem geplanten Wechsel eines künstlichen Kniegelenks ist es höchst selten, dass Patienten an den Folgen\nder Operation sterben. Dennoch können Komplikationen in seltenen Einzelfällen zum Tod führen. ',
                          },
                          result: {
                            rating: 'high',
                            value: '0.5',
                            range: '(0.0 - 1.8)',
                          },
                          explanation: {
                            low: {
                              title: 'Unterdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.8.',
                            },
                            average: {
                              title: 'Durchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.8.',
                            },
                            high: {
                              title: 'Überdurchschnittliche Qualität',
                              text: 'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.',
                              textDetailed:
                                'Nach einer Operation in diesem Krankenhaus ist die Wahrscheinlichkeit zu sterben geringer als in den meisten anderen Krankenhäusern.\nDie Zahl 0.5 gibt das Verhältnis von beobachteten zu erwarteten Komplikationen an. Werte zwischen 0 und 1 zeigen an, dass in einem Krankenhaus weniger Komplikationen als erwartet auftraten, Werte über 1 zeigen an, dass es mehr Komplikationen als erwartet gegeben hat.\nDie Werte in Klammern zeigen, wie sicher die Berechnung ist. Das Verhältnis von beobachteten zu erwarteten Komplikationen liegt mit sehr hoher (95%-iger) Wahrscheinlichkeit zwischen 0 und 1.8.',
                            },
                          },
                        },
                      ],
                    },
                  ],
                  tooltip: {
                    title: 'Qualität nach QSR',
                    tip: 'Mehr Informationen zu den Qualitätsergebnissen für dieses Krankenhaus erhalten Sie im Detailprofil. Das QSR-Verfahren beurteilt die Qualität einer Behandlung anhand von möglichen Komplikationen bzw. unerwünschten Ereignissen. Diese können sowohl während des Krankenhausaufenthalts als auch bis zu einem Jahr nach dem betrachteten Eingriff auftreten. Ausgewertet wurden Eingriffe bei AOK-Patienten über einen mehrjährigen, im Detailprofil angegebenen Zeitraum.\nDie Symbole bedeuten:\n<p>3 grüne Lebensbäume: überdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer geringen Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>2 grüne Lebensbäume: durchschnittliche Qualität (d.h. eine Klinik gehört zu den 60% der Kliniken mit einer mittleren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>1 grüner Lebensbaum: unterdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer höheren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\nMehr zum QSR-Verfahren finden Sie <a title="Link zum QSR Verfahren" href="https://www.qualitaetssicherung-mit-routinedaten.de/" target="_blank" rel="noopener">hier</a>.',
                  },
                  additionalInfo: null,
                  koro: null,
                },
                iqtig: {
                  tooltip: {
                    title: '',
                    tip: 'Alle Krankenhäuser sind verpflichtet, qualitätsrelevante Daten (Qualitätsindikatoren) zur Versorgung ihrer Patientinnen und Patienten zu dokumentieren, die dann vom Institut für Qualitätssicherung und Transparenz im Gesundheitswesen (IQTiG) vergleichend ausgewertet werden. Das IQTIG ist das zentrale Institut für die gesetzlich verankerte Qualitätssicherung im Gesundheitswesen in Deutschland und arbeitet im Auftrag des Gemeinsamen Bundesausschusses.',
                  },
                  data: [],
                },
                koro: null,
                structuredQualityReport: {
                  url: 'http://localhost:8081/sqb/260200320-00-2019.pdf',
                },
                title: 'Qualität',
              },
            },
          },
          {
            id: '260101809-00',
            locationName: 'Schön Klinik Neustadt',
            address: {
              street: 'Am Kiebitzberg 10',
              streetAddition: '',
              zip: '23730',
              city: 'Neustadt in Holstein',
            },
            coordinates: {
              lat: 54.091117980508,
              lon: 10.82867996799,
            },
            peq: {
              general: 89,
              cases: 897,
              average: 81,
            },
            qsr: [
              {
                identifier: 'EHTEP',
                title: 'Hüftgelenkersatz bei Gelenkverschleiß (Arthrose)',
                text: 'Überdurchschnittliche Qualität für "Hüftgelenkersatz bei Gelenkverschleiß (Arthrose)".',
                rating: 3,
                info: null,
                tooltip: null,
                indicators: [],
                status: 0,
                sorting: 0,
              },
              {
                identifier: 'FRHOST',
                title: 'Operation bei hüftgelenknahem Oberschenkelbruch',
                text: 'Überdurchschnittliche Qualität für "Operation bei hüftgelenknahem Oberschenkelbruch".',
                rating: 3,
                info: null,
                tooltip: null,
                indicators: [],
                status: 0,
                sorting: 0,
              },
            ],
            iqtig: null,
            hospital: null,
            treatment: {
              department_id: '',
              department_name: '',
              year: '2019',
              cases: 2197,
              cases_ambulant: 0,
              is_ambulant_treatment: false,
              scoring: 'HIGH',
              cases_ambulant_scoring: null,
              treatment_tip:
                'Der Wert ist im Vergleich zu den Werten anderer Krankenhäuser hoch, er liegt im oberen Viertel.\n',
              ambulant_treatment_tip: null,
              treatmentCases: 2197,
            },
            distance: 0,
            qsrIndicators: [],
            benefits: null,
            generalTooltips: {
              treatmentCases:
                'Angegeben wird die  Anzahl jährlicher Behandlungsfälle für den gesuchten Eingriff. Die Information stammt aus dem Strukturierten Qualitätsbericht des Krankenhauses. Es kann zu geringfügigen Abweichungen gegenüber der tatsächlichen Fallzahl kommen, da geringe Fallzahlen aus Datenschutzgründen nicht genau angezeigt und abgebildet werden dürfen. Je höher die Zahl der Behandlungsfälle ist, desto mehr Erfahrung hat das Krankenhaus mit der jeweiligen Behandlung.  ',
              treatmentCasesAmbulant:
                'Das Krankenhaus ist berechtigt, seltene Erkrankungen, Erkrankungen mit besonderen Krankheitsverläufen und/oder hochspezialisierten Leistungen ambulant zu erbringen.',
              recommendation:
                'Ein Prozentwert von 100% bedeutet, dass alle befragten Patienten dieses Krankenhaus ihrem besten Freund/ihrer besten Freundin weiterempfehlen würden. Die weiße Linie im Balken markiert den Bundesdurchschnitt der Weiterempfehlung, bezogen auf alle deutschen Krankenhäuser. Liegt die weiße Linie im dunkelblauen Bereich, wird dieses Krankenhaus häufiger weiterempfohlen als im Bundesdurchschnitt. Liegt die weiße Linie im hellblauen Bereich, wird dieses Krankenhaus seltener weiterempfohlen als im Bundesdurchschnitt.  Mehr Informationen zu den Patientenbewertungen für dieses Krankenhaus erhalten Sie im Detailprofil. Erläuterungen zum Verfahren finden Sie <a title="Link zum PEQ Verfahren" href="https://www.aok.de/pk/uni/inhalt/versichertenbefragung-peq/" target="_blank" rel="noopener">hier</a>.',
              qsr: 'Mehr Informationen zu den Qualitätsergebnissen für dieses Krankenhaus erhalten Sie im Detailprofil. Das QSR-Verfahren beurteilt die Qualität einer Behandlung anhand von möglichen Komplikationen bzw. unerwünschten Ereignissen. Diese können sowohl während des Krankenhausaufenthalts als auch bis zu einem Jahr nach dem betrachteten Eingriff auftreten. Ausgewertet wurden Eingriffe bei AOK-Patienten über einen mehrjährigen, im Detailprofil angegebenen Zeitraum.\nDie Symbole bedeuten:\n<p>3 grüne Lebensbäume: überdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer geringen Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>2 grüne Lebensbäume: durchschnittliche Qualität (d.h. eine Klinik gehört zu den 60% der Kliniken mit einer mittleren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>1 grüner Lebensbaum: unterdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer höheren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\nMehr zum QSR-Verfahren finden Sie <a title="Link zum QSR Verfahren" href="https://www.qualitaetssicherung-mit-routinedaten.de/" target="_blank" rel="noopener">hier</a>.',
              iqtig:
                'Alle Krankenhäuser sind verpflichtet, qualitätsrelevante Daten (Qualitätsindikatoren) zur Versorgung ihrer Patientinnen und Patienten zu dokumentieren, die dann vom Institut für Qualitätssicherung und Transparenz im Gesundheitswesen (IQTiG) vergleichend ausgewertet werden. Das IQTIG ist das zentrale Institut für die gesetzlich verankerte Qualitätssicherung im Gesundheitswesen in Deutschland und arbeitet im Auftrag des Gemeinsamen Bundesausschusses.',
            },
            isApo: false,
            details: {},
          },
        ],
        count: 2,
        isAop: false,
        isTreatmentReason: true,
        qsrIdentifier: [
          {
            identifier: 'EHTEP',
            title: 'Hüftgelenkersatz bei Gelenkverschleiß (Arthrose)',
          },
          {
            identifier: 'FRHOST',
            title: 'Operation bei hüftgelenknahem Oberschenkelbruch',
          },
        ],
        compareKeys: ['general', 'treatment', 'treatment'],
        generalTooltips: {
          treatmentCases:
            'Angegeben wird die  Anzahl jährlicher Behandlungsfälle für den gesuchten Eingriff. Die Information stammt aus dem Strukturierten Qualitätsbericht des Krankenhauses. Es kann zu geringfügigen Abweichungen gegenüber der tatsächlichen Fallzahl kommen, da geringe Fallzahlen aus Datenschutzgründen nicht genau angezeigt und abgebildet werden dürfen. Je höher die Zahl der Behandlungsfälle ist, desto mehr Erfahrung hat das Krankenhaus mit der jeweiligen Behandlung.  ',
          treatmentCasesAmbulant:
            'Das Krankenhaus ist berechtigt, seltene Erkrankungen, Erkrankungen mit besonderen Krankheitsverläufen und/oder hochspezialisierten Leistungen ambulant zu erbringen.',
          recommendation:
            'Ein Prozentwert von 100% bedeutet, dass alle befragten Patienten dieses Krankenhaus ihrem besten Freund/ihrer besten Freundin weiterempfehlen würden. Die weiße Linie im Balken markiert den Bundesdurchschnitt der Weiterempfehlung, bezogen auf alle deutschen Krankenhäuser. Liegt die weiße Linie im dunkelblauen Bereich, wird dieses Krankenhaus häufiger weiterempfohlen als im Bundesdurchschnitt. Liegt die weiße Linie im hellblauen Bereich, wird dieses Krankenhaus seltener weiterempfohlen als im Bundesdurchschnitt.  Mehr Informationen zu den Patientenbewertungen für dieses Krankenhaus erhalten Sie im Detailprofil. Erläuterungen zum Verfahren finden Sie <a title="Link zum PEQ Verfahren" href="https://www.aok.de/pk/uni/inhalt/versichertenbefragung-peq/" target="_blank" rel="noopener">hier</a>.',
          qsr: 'Mehr Informationen zu den Qualitätsergebnissen für dieses Krankenhaus erhalten Sie im Detailprofil. Das QSR-Verfahren beurteilt die Qualität einer Behandlung anhand von möglichen Komplikationen bzw. unerwünschten Ereignissen. Diese können sowohl während des Krankenhausaufenthalts als auch bis zu einem Jahr nach dem betrachteten Eingriff auftreten. Ausgewertet wurden Eingriffe bei AOK-Patienten über einen mehrjährigen, im Detailprofil angegebenen Zeitraum.\nDie Symbole bedeuten:\n<p>3 grüne Lebensbäume: überdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer geringen Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>2 grüne Lebensbäume: durchschnittliche Qualität (d.h. eine Klinik gehört zu den 60% der Kliniken mit einer mittleren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\n<p>1 grüner Lebensbaum: unterdurchschnittliche Qualität (d.h. eine Klinik gehört zu den 20% der Kliniken mit einer höheren Wahrscheinlichkeit für unerwünschte Ereignisse)</p>\nMehr zum QSR-Verfahren finden Sie <a title="Link zum QSR Verfahren" href="https://www.qualitaetssicherung-mit-routinedaten.de/" target="_blank" rel="noopener">hier</a>.',
          iqtig:
            'Alle Krankenhäuser sind verpflichtet, qualitätsrelevante Daten (Qualitätsindikatoren) zur Versorgung ihrer Patientinnen und Patienten zu dokumentieren, die dann vom Institut für Qualitätssicherung und Transparenz im Gesundheitswesen (IQTiG) vergleichend ausgewertet werden. Das IQTIG ist das zentrale Institut für die gesetzlich verankerte Qualitätssicherung im Gesundheitswesen in Deutschland und arbeitet im Auftrag des Gemeinsamen Bundesausschusses.',
        },
      },
      carehomes: {
        detailsKeyArray: [],
        count: 2,
        results: [
          {
            id: '3',
            locationName: '"Drei Linden" Seniorenpflegestift',
            address: {
              street: 'Auf der Stichel 28',
              streetAddition: '',
              zip: '63762',
              city: 'Großostheim',
            },
            coordinates: {
              lat: 49.91117996018,
              lon: 9.0576249748793,
            },
            distance: 0,
            contribution: [
              {
                amount: '1.760,74 €',
                careLevel: '1',
                tooltip: 'zzgl. Investitionskosten',
                contractId: null,
                type: 'personalContribution',
              },
              {
                amount: '1.458,64 €',
                careLevel: '2-5',
                tooltip: 'zzgl. Investitionskosten',
                contractId: null,
                type: 'personalContribution',
              },
            ],
            phone: '06026 / 97260',
            fax: '06026 / 972648',
            benefits: null,
            email: 'drei.linden@t-online.de',
            website: 'http://www.dreilinden-seniorenpflege.de',
            transparencyReport: null,
            details: {},
          },
          {
            id: '4',
            locationName: '"Finkenhof" Senioren- & Pflegeheim',
            address: {
              street: 'Finkenweg 2',
              streetAddition: '',
              zip: '83253',
              city: 'Rimsting',
            },
            coordinates: {
              lat: 47.879117959865,
              lon: 12.338356923952,
            },
            distance: 0,
            contribution: [
              {
                amount: '2.360,01 €',
                careLevel: '1',
                tooltip: 'zzgl. Investitionskosten',
                contractId: null,
                type: 'personalContribution',
              },
              {
                amount: '2.205,75 €',
                careLevel: '2-5',
                tooltip: 'zzgl. Investitionskosten',
                contractId: null,
                type: 'personalContribution',
              },
            ],
            phone: '08051 / 963540',
            fax: '08051 / 96354210',
            benefits: null,
            email: 'info@finkenhof-rimsting.de',
            website: 'http://www.finkenhof-rimsting.de',
            transparencyReport: null,
            details: {},
          },
        ],
        compareKeys: ['contribution'],
        generalTooltips: {
          transparencyReport:
            'Dieser Transparenzbericht wurde auf Grundlage der ab 1. Januar 2017 gültigen Pflegetransparenzverordnung erstellt. Ein direkter Vergleich der Bewertung mit Transparenzberichten oder Berichten zu Qualitätsprüfungen nach einer anderen Prüfgrundlage ist aufgrund der unterschiedlichen Bewertungssystematik nicht möglich.',
          distance:
            'Die hier dargestellte Entfernungsangabe basiert auf der Entfernung einer von Google berechneten Route.',
        },
      },
      careservices: {
        detailsKeyArray: [],
        count: 0,
        results: [],
        compareKeys: [],
        generalTooltips: null,
      },
      dayandnightcare: {
        detailsKeyArray: [],
        count: 0,
        results: [],
        compareKeys: [],
        generalTooltips: null,
      },
      caresupport: {
        detailsKeyArray: [],
        count: 0,
        results: [],
        compareKeys: [],
        generalTooltips: null,
      },
    },
    activeElements: {
      type: 'carehomes',
      activeIds: ['3', '4'],
    },
    xhr: {
      doctors: {
        initial: null,
        details: [],
      },
      hospitals: {
        initial: true,
        details: ['260200320-00', '260101809-00'],
      },
      carehomes: {
        initial: true,
        details: ['3', '4'],
      },
      careservices: {
        initial: null,
        details: [],
      },
      dayandnightcare: {
        initial: null,
        details: [],
      },
      caresupport: {
        initial: null,
        details: [],
      },
    },
    totalCount: 0,
  },
  _persist: {
    version: -1,
    rehydrated: true,
  },
}

export default exampleStoreStorybook
